import { Link } from "@tanstack/react-router";
import { useAuth } from "@/lib/hooks";
import { legalEntity, supportEmail } from "@/lib/config";

export function SiteFooter() {
  const { isAuthenticated } = useAuth();

  return (
    <footer className="surface-ink mt-24">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-14 sm:grid-cols-2 lg:grid-cols-5">
        <div className="lg:col-span-1">
          <p className="font-display text-2xl">Sir Levantine</p>
          <p className="eyebrow mt-1 text-ink-foreground/60">Property Investment Academy</p>
          <p className="mt-4 max-w-xs text-sm text-ink-foreground/70">
            Education, mentorship and hands-off deal sourcing for UK property investors.
          </p>
        </div>

        <div>
          <p className="eyebrow text-gold">Learn</p>
          <ul className="mt-4 space-y-2 text-sm text-ink-foreground/75">
            <li>
              <Link to="/blueprint">The Blueprint Book</Link>
            </li>
            <li>
              <Link to="/academy">Academy Portal</Link>
            </li>
            <li>
              <Link to="/mentorship">Mentorship Schemes</Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="eyebrow text-gold">Services</p>
          <ul className="mt-4 space-y-2 text-sm text-ink-foreground/75">
            <li>
              <Link to="/deal-sourcing">Deal Sourcing</Link>
            </li>
            <li>
              <Link to="/deal-analyzer">AI Deal Analyzer</Link>
            </li>
            <li>
              <Link to="/about">About the Founder</Link>
            </li>
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="eyebrow text-gold">Members</p>
          <ul className="mt-4 space-y-2 text-sm text-ink-foreground/75">
            {isAuthenticated ? (
              <>
                <li>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li>
                  <Link to="/billing">Billing</Link>
                </li>
                <li>
                  <Link to="/profile">Profile</Link>
                </li>
              </>
            ) : (
              <>
                <li>
                  <Link to="/login">Login</Link>
                </li>
                <li>
                  <Link to="/signup">Sign Up</Link>
                </li>
              </>
            )}
          </ul>
        </div>

        <div>
          <p className="eyebrow text-gold">Legal</p>
          <ul className="mt-4 space-y-2 text-sm text-ink-foreground/75">
            <li>
              <Link to="/legal/terms">Terms of Service</Link>
            </li>
            <li>
              <Link to="/legal/privacy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/legal/subscription">Subscription Policy</Link>
            </li>
            <li>
              <Link to="/legal/refunds">Refund Policy</Link>
            </li>
            <li>
              <Link to="/legal/data-processing">Data Processing Agreement</Link>
            </li>
            <li>
              <Link to="/legal/delete-account">Delete Account</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-ink-foreground/10">
        <div className="mx-auto flex max-w-6xl flex-col gap-2 px-5 py-6 text-xs text-ink-foreground/55 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {new Date().getFullYear()} {legalEntity}. All rights reserved. ·{" "}
            <a href={`mailto:${supportEmail}`} className="hover:text-ink-foreground">
              {supportEmail}
            </a>
          </p>
          <p>
            Prices include applicable UK VAT (20%) on digital services. Property investment carries
            risk; capital is at risk.
          </p>
        </div>
      </div>
    </footer>
  );
}
